// These functions should be used in saga handlers only

import { ORDER_TYPE, TRANSACTION_TYPES } from "../../../constants/equity/common";

import commonBaseService from "../../commonBaseService";
import commonDateService from "../../commonDateService";
import { map } from "lodash-es";
import stocksPortfolioFormatterService from "./stocksPortfolioFormatterService";
import stocksPortfolioService from "./stocksPortfolioService";

const filterHoldingsInvalidDataResponse = (holdings) => {
	const filteredHoldings = {};
	Object.entries(holdings).forEach(([key, value]) => {
		const hasNseTokenAndSegment = value.nse_token && value.nse_segment_id;
		const hasBseTokenAndSegment = value.bse_token && value.bse_segment_id;
		if (hasNseTokenAndSegment || hasBseTokenAndSegment) {
			filteredHoldings[key] = value;
		}
	});
	return filteredHoldings;
};

const filterPositionsInvalidDataResponse = (positions = []) => {
	const filteredPositions = positions.filter((item) => {
		const hasTokenAndExchange = item.exchange && item.scrip_token;
		return hasTokenAndExchange;
	});
	return filteredPositions;
};

const formatPositionsObject = (positionsList = []) => {
	const positions = {};
	positionsList.forEach((item) => {
		const key = stocksPortfolioService.createPositionId(item.exchange, item.scrip_token, item.product_type);
		positions[key] = item;
	});
	return positions;
};

const formatInvestmentHistoryData = (data = {}) => {
	return Object.entries(data).map(([key, value]) => {
		const title = key.toUpperCase();
		// Product logic given by manish during previous implementation
		const formattedData = value.map(({ DDTOFTRAN, NQUANTITY, COPERATION, NAMOUNT, DAYS }) => {
			const date = commonDateService.formatDateTime(DDTOFTRAN, 'M/dd/yyyy hh:mm:ss a', 'dd MMM yyyy');
			const status = TRANSACTION_TYPES[COPERATION];
			const investedValue = commonBaseService.formatNumber(NAMOUNT, {
				addCurrencySymbol: true,
				decimalPlaces: 0,
			});
			const averagePrice = Math.abs(NAMOUNT / NQUANTITY);
			const average = commonBaseService.getNumberInDecimalFormat(averagePrice, 2);
			const isStcgTransaction = key === 'stcg';
			const isSellStatus = status === 'SELL';
			const isLTCGTagVisible = isStcgTransaction && !isSellStatus;
			const LTCGValue = `${DAYS} days to LTCG`;

			return {
				date: date,
				quantity: NQUANTITY,
				average: average,
				status: status,
				investedValue: investedValue,
				showLtcgTag: isLTCGTagVisible,
				ltcgValue: LTCGValue,
			};
		});

		return {
			title: title,
			data: formattedData,
		};
	});
};

const formateBulkSquareoffPayload = (squareoffIds = [], positionsData = {}, appVersion = '') => {
	const selectedPositionsData = [];
	for (let i = 0; i < squareoffIds.length; i++) {
		const positionDetails = positionsData[squareoffIds[i]];
		selectedPositionsData.push(positionDetails);
	}
	const formatedPayload = map(selectedPositionsData, (data) => _formatPositionDetailsForSquareoff(data, appVersion));
	return formatedPayload;
};


const _formatPositionDetailsForSquareoff = (data = {}, appVersion) => {
	// default values are assigned only if key is undefined,
	// therefore fallback values are used while creating orderData object
	const {
		exchange = '',
		series = '',
		expiry_date = '',
		instrument = '',
		option_type = '',
		product_type = '',
		strike_price = '',
		symbol = '',
		overall_net_quantity = '',
		scrip_token = '',
		market_lot = 1,
	} = data;
	const squareoffOrderQuantity = stocksPortfolioService.getAbsoluteNetQuantity(overall_net_quantity);
	const formatedExpiryDate = stocksPortfolioFormatterService.getFormattedExpiryDate(expiry_date);
	// Quantity is already multiplied with market_lot in api response
	const quantity = squareoffOrderQuantity;
	const orderData = {
		scrip_info: {
			exchange: exchange,
			scrip_token: parseInt(scrip_token, 10),
			symbol: symbol,
			expiry_date: formatedExpiryDate,
			series: series || 'XX',
			strike_price: strike_price || 0.0,
			option_type: option_type || '',
			instrument_name: !instrument ? instrument : 'EQUITIES', // handling '0' as instrument value for MTF position
		},
		transaction_type: overall_net_quantity > 0 ? TRANSACTION_TYPES.SELL : TRANSACTION_TYPES.BUY,
		product_type: product_type,
		order_type: ORDER_TYPE.MARKET,
		quantity: quantity,
		validity: 'DAY',
		is_amo: false,
		order_identifier: appVersion,
		trigger_price: 0,
		disclosed_quantity: 0,
	};
	return orderData;
};


const stocksPortfolioSagaService = {
    filterHoldingsInvalidDataResponse,
    filterPositionsInvalidDataResponse,
	formatPositionsObject,
	formatInvestmentHistoryData,
	formateBulkSquareoffPayload
}

export default stocksPortfolioSagaService